import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/arrow_out.svg");
;
import(/* webpackMode: "eager" */ "/app/public/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/news/deflatory_token.png");
;
import(/* webpackMode: "eager" */ "/app/public/news/fuel_new_economy.webp");
;
import(/* webpackMode: "eager" */ "/app/public/news/listed_on_coinsph.webp");
;
import(/* webpackMode: "eager" */ "/app/public/news/step_jars.webp");
;
import(/* webpackMode: "eager" */ "/app/public/news/whitepaper.webp");
;
import(/* webpackMode: "eager" */ "/app/public/partners/AUDIBLE.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITVAVO.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/COCA.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/COINGECKO.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/FREECASH.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/GOMINING.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/HELIUM_MOBILE.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/KRAKEN.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/MORALIS.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR_AI.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NOOM.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/PRODEGE.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/PROPHETMARKET.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/SWEATCOIN.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/UPLAND.svg");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_round.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_square.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweateconomy_logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/FloatingGetWallet/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/InstallSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/News/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/PartnersMarquee/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/PhonesCarousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/SectionLink/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/TextReveal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/VisibilityTracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/WelcomeMovingFigure/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/WelcomeTokenSection/LandingZoneComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/WelcomeTokenSection/styles.module.css");
